import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../util/assets';
import InputGroup from '../../../../../components/global/InputGroup';
import Button from '../../../../../components/global/Button';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const EmailVerificationStep = ({
  values,
  loading,
  handleChange,
  handleSubmit,
}) => {
  return (
    <Fragment>
      <h4 className="px-2">Please confirm your email</h4>
      <p className="px-2">
        Make sure you never lose access to your account by verifying your email.
      </p>
      <form onSubmit={handleSubmit} className="px-2">
        <InputGroup
          id="email_address"
          type="email"
          name="email_address"
          addon={<img alt="" src={getAsset('/shutterbug/icons/email.svg')} />}
          placeholder="Is this your email address?"
          value={values.email_address}
          onChange={handleChange}
          wrapperClassName="marketing-account-matches-email-input"
        />

        <div>
          <Button
            type="submit"
            disabled={loading}
            loading={loading}
            className="d-block mt-2"
          >
            {loading ? 'Processing...' : 'Yes, this is my email'}
          </Button>

          <Button
            type="button"
            btnStyle="link"
            className="d-block mt-2"
            disabled={loading}
            onClick={() => {
              handleChange({
                target: {
                  name: 'should_verify_email_address',
                  value: false,
                },
              });
              handleSubmit();
            }}
          >
            No, this is not my email
          </Button>
        </div>
      </form>
    </Fragment>
  );
};

EmailVerificationStep.propTypes = propTypes;

export default EmailVerificationStep;
